import React from 'react'
const AdvertiserPanel = ({ children }) => {
    return (
        <div className=' theme-bg-color-secondary  p-2 adminHeadContainer'>{children} </div>
    )
}

export default AdvertiserPanel